import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Glass() {
	return (
		<div>
			<NeonHero
				title="Auto Glass"
				subtitle="Repair & replacement with ADAS calibrations. Proven workflow from our AutoGlass sister company."
				primaryCta={{ label: 'Book Glass Service', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Capabilities</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Windshield repair and replacement</li>
					<li>Side, roof and back glass</li>
					<li>ADAS camera calibrations</li>
					<li>Insurance claims management</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Digital intake & glass spec ID</li>
							<li>Parts sourcing and scheduling</li>
							<li>Install and ADAS calibration</li>
							<li>QA and documentation</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Affirm and Klarna at checkout. 0% for 12 months with approved credit.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Repair: ~1 hour. Replacement + calibration: 2–4 hours on average.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
